import axios from 'axios'

class WebhookService {
  _getBaseUrl(colaboradorId) {
    return `api/v1/gerencial/${colaboradorId}/webhooks/`
  }

  // Listar todos os webhooks
  async getAll(colaboradorId, params = {}) {
    try {
      const { data } = await axios.get(this._getBaseUrl(colaboradorId), { params })
      return data
    } catch (error) {
      console.error('Erro ao buscar webhooks:', error)
      return Promise.reject(error)
    }
  }

  // Buscar webhook por ID
  async get(colaboradorId, public_id) {
    try {
      const { data } = await axios.get(`${this._getBaseUrl(colaboradorId)}${public_id}/`)
      return data
    } catch (error) {
      console.error('Erro ao buscar webhook:', error)
      return Promise.reject(error)
    }
  }

  // Criar novo webhook
  async create(colaboradorId, webhookData) {
    try {
      const { data } = await axios.post(this._getBaseUrl(colaboradorId), webhookData)
      return Promise.resolve(data)
    } catch (error) {
      console.error('Erro ao criar webhook:', error)
      return Promise.reject(error)
    }
  }

  // Atualizar webhook
  async update(colaboradorId, public_id, webhookData) {
    try {
      const { data} = await axios.put(`${this._getBaseUrl(colaboradorId)}${public_id}/`, webhookData)
      return Promise.resolve(data)
    } catch (error) {
      console.error('Erro ao atualizar webhook:', error)
      return Promise.reject(error)
    }
  }

  async delete(colaboradorId, public_id) {
    try {
      await axios.delete(`${this._getBaseUrl(colaboradorId)}${public_id}/`)
      return Promise.resolve()
    } catch (error) {
      console.error('Erro ao excluir webhook:', error)
      return Promise.reject(error)
    }
  }

  // Testar webhook
  async test(colaboradorId, public_id) {
    try {
      const { data } = await axios.post(`${this._getBaseUrl(colaboradorId)}${public_id}/test/`)
      return Promise.resolve(data)
    } catch (error) {
      console.error('Erro ao testar webhook:', error)
      return Promise.reject(error)
    }
  }

  // Buscar logs do webhook
  async getLogs(colaboradorId, id, params = {}) {
    try {
      const { data } = await axios.get(`${this._getBaseUrl(colaboradorId)}${id}/logs/`, { params })
      return Promise.resolve(data)
    } catch (error) {
      return Promise.reject(error)
    }
  }

  // Ativar/Desativar webhook
  async toggleStatus(colaboradorId, id, ativo) {
    try {
      const { data } = await axios.patch(`${this._getBaseUrl(colaboradorId)}${id}/status/`, { ativo })
      return Promise.resolve(data)
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default new WebhookService()